// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__YO7J6","total":"Cart_total__F-EkC","actions":"Cart_actions__l1l2y","button--alt":"Cart_button--alt__PSeXC"};